import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class DataAnalyticsService {
  private pendoLoaded = false;
  private readonly renderer: Renderer2;

  constructor(
    private readonly rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadAnalytics(): void {
    this.loadPendoScript();
  }

  loadPendoScript(): void {
    if (this.pendoLoaded) {
      return;
    }

    if (environment.production && environment.PENDO_KEY !== "") {
      const pendoScript = this.renderer.createElement("script");
      const PENDOKEY = environment.PENDO_KEY;
      pendoScript.type = "text/javascript";
      pendoScript.text = `
        (function(apiKey){
          (function(p,e,n,d,o){
            var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track'];
            for(w=0,x=v.length;w<x;w++)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));}
            })(v[w]);
            y=e.createElement(n);y.async=!0;
            y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
            z=e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y,z);
          })(window,document,'script','pendo');
        })('${PENDOKEY}');
          `;
      this.renderer.appendChild(this.document.body, pendoScript);
      this.pendoLoaded = true;
    }
  }
}
